import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=2bdbd33c&scoped=true"
import script from "./TabsNavigation.vue?vue&type=script&lang=js"
export * from "./TabsNavigation.vue?vue&type=script&lang=js"
import style0 from "./TabsNavigation.vue?vue&type=style&index=0&id=2bdbd33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdbd33c",
  null
  
)

export default component.exports